(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vessel-hotspot-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vessel-hotspots')) {
    customElements.define(
      'vessel-hotspots',
      class VesselHotspots extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.abortController = new AbortController();

          const signal = this.abortController.signal;
          const source = this.querySelector('[data-vh-source]');
          const layer = this.querySelector('[data-vh-hotspot-layer]');

          this.track = this.querySelector('[data-vh-track]');
          this.slider = this.querySelector('[data-vh-slider]');
          this.status = this.querySelector('[data-vh-status]');
          this.controls = this.querySelector('[data-vh-controls]');
          this.pagination = this.querySelector('[data-vh-pagination]');
          this.previous = this.querySelector('[data-vh-prev]');
          this.next = this.querySelector('[data-vh-next]');

          this.items = Array.from(
            source.querySelectorAll('[data-vh-item]')
          );

          this.hotspots = [];
          this.slides = [];
          this.paginationButtons = [];
          this.pauseReasons = new Set();

          /*
           * Keep each theme block wrapper intact so selecting
           * a hotspot block continues to work in the editor.
           */
          this.items.forEach((item, index) => {
            const hotspot = item.querySelector('[data-vh-hotspot]');
            const slide = item.querySelector('[data-vh-slide]');

            hotspot.style.cssText += item.style.cssText;
            hotspot.dataset.index = String(index);

            layer.appendChild(hotspot);

            item.style.display = 'contents';
            this.track.appendChild(item);

            this.hotspots.push(hotspot);
            this.slides.push(slide);

            const paginationButton = document.createElement('button');
            paginationButton.type = 'button';
            paginationButton.className = 'vh-pagination-button';

            paginationButton.setAttribute(
              'aria-label',
              `Show product ${index + 1}: ${hotspot.getAttribute('aria-label')}`
            );

            paginationButton.setAttribute('aria-controls', slide.id);

            this.pagination.appendChild(paginationButton);
            this.paginationButtons.push(paginationButton);

            hotspot.addEventListener(
              'click',
              () => this.select(index),
              { signal }
            );

            paginationButton.addEventListener(
              'click',
              () => this.select(index),
              { signal }
            );
          });

          this.count = this.slides.length;

          const hasMultiple = this.count > 1;
          const showPagination = this.dataset.showPagination === 'true';
          const showArrows = this.dataset.showArrows === 'true';

          this.pagination.hidden = !hasMultiple || !showPagination;
          this.previous.hidden = !hasMultiple || !showArrows;
          this.next.hidden = !hasMultiple || !showArrows;
          this.controls.hidden =
            !hasMultiple || (!showPagination && !showArrows);

          this.previous.addEventListener(
            'click',
            () => this.select(this.index - 1),
            { signal }
          );

          this.next.addEventListener(
            'click',
            () => this.select(this.index + 1),
            { signal }
          );

          this.slider.addEventListener(
            'keydown',
            (event) => {
              if (event.target !== this.slider) return;

              if (event.key === 'ArrowRight') {
                event.preventDefault();
                this.select(this.index + 1);
              }

              if (event.key === 'ArrowLeft') {
                event.preventDefault();
                this.select(this.index - 1);
              }
            },
            { signal }
          );

          if (this.dataset.swipe === 'true') {
            this.slider.addEventListener(
              'pointerdown',
              (event) => {
                if (event.pointerType === 'mouse') return;

                this.pointerStart = {
                  x: event.clientX,
                  y: event.clientY
                };
              },
              { signal }
            );

            this.slider.addEventListener(
              'pointerup',
              (event) => {
                if (!this.pointerStart) return;

                const dx = event.clientX - this.pointerStart.x;
                const dy = event.clientY - this.pointerStart.y;
                this.pointerStart = null;

                if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
                  this.select(this.index + (dx < 0 ? 1 : -1));
                }
              },
              { signal }
            );

            this.slider.addEventListener(
              'pointercancel',
              () => {
                this.pointerStart = null;
              },
              { signal }
            );
          }

          this.addEventListener(
            'mouseenter',
            () => this.pause('hover'),
            { signal }
          );

          this.addEventListener(
            'mouseleave',
            () => this.resume('hover'),
            { signal }
          );

          this.addEventListener(
            'focusin',
            () => this.pause('focus'),
            { signal }
          );

          this.addEventListener(
            'focusout',
            (event) => {
              if (!this.contains(event.relatedTarget)) {
                this.resume('focus');
              }
            },
            { signal }
          );

          document.addEventListener(
            'visibilitychange',
            () => {
              if (document.hidden) {
                this.pause('hidden');
              } else {
                this.resume('hidden');
              }
            },
            { signal }
          );

          document.addEventListener(
            'shopify:block:select',
            (event) => {
              const index = this.items.findIndex(
                (item) => item.dataset.blockId === event.detail.blockId
              );

              if (index < 0) return;

              this.pause('editor');
              this.select(index, false, false);
            },
            { signal }
          );

          document.addEventListener(
            'shopify:block:deselect',
            (event) => {
              if (
                this.items.some(
                  (item) => item.dataset.blockId === event.detail.blockId
                )
              ) {
                this.resume('editor');
              }
            },
            { signal }
          );

          this.select(
            Number(this.dataset.initial || 1) - 1,
            false,
            false
          );

          if (document.hidden) this.pauseReasons.add('hidden');

          this.startAutoplay();
        }

        select(index, announce = true, restart = true) {
          if (!this.count) return;

          this.index = ((index % this.count) + this.count) % this.count;

          this.track.style.transform =
            `translateX(-${this.index * 100}%)`;

          this.slides.forEach((slide, slideIndex) => {
            const active = slideIndex === this.index;

            slide.inert = !active;
            slide.setAttribute('aria-hidden', String(!active));
          });

          this.hotspots.forEach((hotspot, hotspotIndex) => {
            const active = hotspotIndex === this.index;

            hotspot.classList.toggle('is-active', active);
            hotspot.setAttribute('aria-pressed', String(active));
          });

          this.paginationButtons.forEach((button, buttonIndex) => {
            const active = buttonIndex === this.index;

            button.classList.toggle('is-active', active);

            if (active) {
              button.setAttribute('aria-current', 'true');
            } else {
              button.removeAttribute('aria-current');
            }
          });

          if (announce) {
            this.status.textContent =
              `Product ${this.index + 1} of ${this.count}: ` +
              this.hotspots[this.index].getAttribute('aria-label');
          }

          if (restart) this.startAutoplay();
        }

        pause(reason) {
          this.pauseReasons.add(reason);
          clearInterval(this.timer);
        }

        resume(reason) {
          this.pauseReasons.delete(reason);
          this.startAutoplay();
        }

        startAutoplay() {
          clearInterval(this.timer);

          if (
            this.dataset.autoplay !== 'true' ||
            this.count < 2 ||
            this.pauseReasons.size ||
            window.Shopify?.designMode ||
            window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ) {
            return;
          }

          this.timer = setInterval(
            () => this.select(this.index + 1, false, false),
            Number(this.dataset.interval) || 5000
          );
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          this.abortController?.abort();
          this.initialized = false;

          /*
           * Restore the original block markup if this element
           * is detached and reinserted.
           */
          const source = this.querySelector('[data-vh-source]');

          this.items?.forEach((item, index) => {
            item.prepend(this.hotspots[index]);
            item.style.removeProperty('display');
            source?.appendChild(item);
          });

          this.pagination?.replaceChildren();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
